await import('/home/sysipb/meow-media-frontend/node_modules/.pnpm/@umijs+bundler-webpack@4.6.33_type-fest@1.4.0_typescript@5.9.3_webpack@5.105.4/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/home/sysipb/meow-media-frontend/src/.umi/umi.ts');
export default 1;